import styles from "../Filters.module.scss";
import { FilterItemProps } from "components/Filters/Filters";
import { ComponentChildren, h } from "preact";
import { Text } from "preact-i18n";

interface FilterWithLabelProps extends Pick<
    FilterItemProps,
    "addressId" | "labelId" | "fieldName"
> {
    children: ComponentChildren;
}

const FilterWithLabel = (props: FilterWithLabelProps) => {
    const { addressId, labelId, fieldName, children } = props;

    return (
        <div className={""}>
            <label
                className={styles.fitlerItemLabel}
                htmlFor={`${fieldName}-${addressId}`}
            >
                {labelId && <Text id={labelId}>Label</Text>}
            </label>
            <div className={""}>{children}</div>
        </div>
    );
};

export default FilterWithLabel;
